import { Vue, Component, Ref, Emit } from 'vue-property-decorator'
import BillingAddToGridComponent from '@/modules/billing-module/shared/components/add-to-grid/billing-add-to-grid.vue'
import { BModal } from 'bootstrap-vue'
import {
    BillingModalInvoicesAddToParams,
    BillingModalInvoicesAddToState,
    initialBillingModalInvoicesAddToState
} from '@/modules/billing-module/components/modal/invoices/add-to/billing-modal-invoices-add-to.model'
import { billingCommonInvoiceService } from '@/api/services/billing/common-invoice/billing-common-invoice.service'
import { store } from '@/store/store'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { BillingModalInvoicesAddToGridDatasource } from '@/modules/billing-module/components/modal/invoices/add-to/config/billing-modal-invoices-add-to-grid.datasource'
import {
    InvoiceDeliveryNoteAddDetachRequest,
    InvoiceResponse
} from '@/api/services/billing/common-invoice/billing-common-invoice.dto'
import { BillingOperationWithConceptsGuard } from '@/modules/billing-module/shared/guards/billing-operation-with-concepts-guard'

@Component({
    components: {
        BillingAddToGridComponent
    }
})
export default class BillingModalInvoicesAddTo extends Vue {
    @Ref() readonly invoicesAddTo!: BModal

    @Emit()
    added(invoiceId: number): number {
        return invoiceId
    }

    state: BillingModalInvoicesAddToState
    constructor() {
        super()
        this.state = initialBillingModalInvoicesAddToState()
    }

    async show(params: BillingModalInvoicesAddToParams): Promise<void> {
        const { deliveryNotes } = params
        this.state = {
            ...initialBillingModalInvoicesAddToState(),
            datasource: new BillingModalInvoicesAddToGridDatasource(deliveryNotes)
        }
        this.invoicesAddTo.show()
    }
    hide(): void {
        this.invoicesAddTo.hide()
    }

    async onInvoiceSelected(invoice: InvoiceResponse): Promise<void> {
        if (this.state.datasource) {
            const { deliveryNotes } = this.state.datasource
            const numberOfConcepts =
                deliveryNotes.reduce((accumulator, deliveryNote) => {
                    return accumulator + deliveryNote.numberOfconcepts
                }, 0)
            await BillingOperationWithConceptsGuard.run(
                numberOfConcepts,
                async () => {
                    const request: InvoiceDeliveryNoteAddDetachRequest = {
                        deliveryNoteIds: deliveryNotes.map(deliveryNote => deliveryNote.id)
                    }
                    const response =
                        await PromiseUtils.toCallSecure(
                            billingCommonInvoiceService.addDeliveryNotes(
                                store.state.labId,
                                invoice.id,
                                request))
                    if (response !== null) {
                        this.added(invoice.id) // emits an event
                    }
                }
            )
        }
    }
}
